import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "survey-thank-you" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" We thank you for your time spent taking this survey. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Your response has been recorded. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_h1 = _resolveComponent("n-h1")!
  const _component_n_button = _resolveComponent("n-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_n_h1, null, {
      default: _withCtx(() => [
        _createTextVNode("Thank You")
      ]),
      _: 1
    }),
    _hoisted_2,
    _createVNode(_component_n_button, {
      type: "primary",
      onClick: _ctx.close
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Close ")
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
}